import { withInstall } from '../utils/index';
import Video from './index.vue';
import './index.less';

export const TlbsVideo = withInstall(Video);
export default TlbsVideo;
